/* eslint-disable react/prop-types */
import { useState } from "react";
import { BiSolidHide } from "react-icons/bi";
import { BiSolidShow } from "react-icons/bi";

export default function PasswordField(props) {
  const { label, name, formik, placeholder, disabled = false } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      {label ? (
        <label className="block mb-2 text-sm font-medium text-[#494949]">
          {label}
        </label>
      ) : null}
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          name={name}
          value={formik.values[name]}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className="py-4 px-3 bg-[#E4E6E3] w-full border-none placeholder:text-info focus:text-info focus:border-none outline-none focus:outline-none focus:ring-0 font-imprima"
          placeholder={placeholder}
          disabled={disabled}
        />
        <span
          className="absolute top-1/2 right-4 cursor-pointer"
          onClick={handleTogglePassword}
        >
          {showPassword ? <BiSolidShow /> : <BiSolidHide />}
        </span>
      </div>
      {formik.touched[name] && formik.errors[name] && (
        <div className="relative py-5">
          <div className="absolute top-0 pt-0 text-[12px] text-red-600 font-imprima">
            {formik.errors[name]}
          </div>
        </div>
      )}
      {/* <div className="relative py-5">
        {formik.touched[name] && formik.errors[name] && (
          <div className="absolute top-0 pt-0 text-[12px] text-red-600 font-imprima">
            {formik.errors[name]}
          </div>
        )}
      </div> */}
    </>
  );
}
